import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lazy-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lazy-loading.component.html',
  styleUrl: './lazy-loading.component.scss'
})
export class LazyLoadingComponent {
  @Input()
  show: boolean = true;
}
